/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoleRead
 */
export interface RoleRead {
    /**
     * 
     * @type {string}
     * @memberof RoleRead
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof RoleRead
     */
    id: number;
}

/**
 * Check if a given object implements the RoleRead interface.
 */
export function instanceOfRoleRead(value: object): value is RoleRead {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function RoleReadFromJSON(json: any): RoleRead {
    return RoleReadFromJSONTyped(json, false);
}

export function RoleReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleRead {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'id': json['id'],
    };
}

export function RoleReadToJSON(json: any): RoleRead {
    return RoleReadToJSONTyped(json, false);
}

export function RoleReadToJSONTyped(value?: RoleRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'id': value['id'],
    };
}

